import { Component } from "react-image-crop";
import Table from "../../components/table/Table";
import DropdownAction from "../../components/dropdown/DropdownAction";
import ActionContainer from "../../components/UIComponent/ActionTableComponent/actionContainer";
import BookingServices from "../../services/axiosServices/apiServices/BookingServices";
import SwalServices from "../../services/swalServices/SwalServices";
import moment from "moment";
import { saveAs } from "file-saver";
import { WebPath } from "../../utils/AppSetting";
import { encryptAES } from "../../utils/Encryption";


export default class ViewWaitingList extends Component {
  constructor(props) {
    super(props);
    this.BookingServices = new BookingServices()
    this.swalServices = new SwalServices();
    this.state = {
      pagination: {
        pageNo: 1,
        pageSize: 10,
        orderByColumn: "",
        orderFlag: 0,
        searchText: "",
        status: 0,
        dateFrom: "",
        dateTo: "",
        // selectedEvent: [],
      },
      actionDropdown: ["Notify"],
      totalResultes: "",
      bookingWaitingList: [],
      bookingWaiting: [],
      isLoading: false,
    }
  }

  setPagination = (newPagination) => {
    this.setState({ pagination: newPagination });
    this.getAllBookingWaitingList(newPagination)
  };

  getAllBookingWaitingList = (pagination = this.state.pagination) => {
    this.setState({ isLoading: true });
    this.BookingServices.getAllBookingWaitingList(pagination).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        let details = response.responseItem.responseContent.itemList;
        details.map((key, index) => {
          key.eventDate = key.eventDate
            ? moment(key.eventDate).format("DD MMM YYYY")
            : "-";
          return key;
        });
        this.setState({ bookingWaitingList: details }, () => {

        });
        this.setState({
          totalResultes: response.responseItem.responseContent.totalCount,
        });
      } else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoading: false });
    });
  };


  getBookingWaitingDetailsById = (bookingWaitingListId, eventId, eventTypeId, eventTimeSlotId) => {
    let encryptEventId = encryptAES(eventId);
    let encryEventTimeslotId = encryptAES(eventTimeSlotId)
    let eventTypeName = "";
    if (eventTypeId === 1 || eventTypeId === 4 || eventTypeId === 2 ||  eventTypeId === 9 ||  eventTypeId === 10) {
      eventTypeName = "workshopDetails"; //Workshop Type
    } else if (eventTypeId === 3) {
      eventTypeName = "conferenceDetails"; // Conference Type
    } else {
      eventTypeName = "formDetails"; // Form Type
    }
    let host = WebPath;
    let generateUrl = "";
    if (eventTypeId === 3) {
      generateUrl = `${host}programmes/${eventTypeName}/${encryptEventId}?timeSlot=${encryEventTimeslotId}`;
    } else {
      generateUrl = `${host}programmes/${eventTypeName}/${encryptEventId}`;
    }

    const request = { bookingWaitingListId, generateUrl };
    this.setState({ isLoading: true });
    this.BookingServices.getBookingWaitingDetailsById(request).then((response) => {
      this.setState({ isLoading: false });

      if (response.statusCode === 200 && response.responseItem != null) {
        if (response.message === null) {
          this.swalServices.Success("Booking waiting details Notified");
          this.getAllBookingWaitingList();
        }
        this.setState({
          waitingDetails: response.responseItem.responseContent,
        });

        // Optional: window.location.reload();
      } else {
        this.swalServices.Error(response.message);
      }
    });
  };


  actionClick = (index, value, option, event) => {
    if (option === "Notify") {

      if (value && value > 0) {
        let details = this.state.bookingWaitingList;
        let bookingWaiting = details.find((x) => x.bookingWaitingListId === value)
        if (bookingWaiting) {
          this.getBookingWaitingDetailsById(bookingWaiting.bookingWaitingListId, bookingWaiting.eventId, bookingWaiting.eventTypeId, bookingWaiting.eventTimeSlotId);
        }
      }
    }
  };

  actions = (element, index, value) => {
    return element !== "EventId" ? null : (
      <td>
        <div className="relative w-full credit-note-action-dropdown">
          <ActionContainer>
            <div className="mr-8">
              <DropdownAction
                key={index}
                value={value}
                id={index}
                index={index}
                options={this.state.actionDropdown}
                align="right"
                onOptionClick={this.actionClick.bind(this)}
              />
            </div>
          </ActionContainer>
        </div>
      </td>
    );
  };


  searchByName = (value) => {
    let detail = this.state.pagination;
    detail.searchText = "";
    this.setState({ pagination: { ...detail } });
    if (value.length > 2) {
      detail.pageNo = 1;
      detail.pageSize = 10;
      detail.searchText = value;
      this.setState({ pagination: { ...detail } });
    }
    this.getAllBookingWaitingList();
  };

  handleChange(event) {
    const value = event.target.value;
    const name = event.target.name;
    let detail = this.state.pagination;
    let fulldate = (detail[name] = value === "" ? null : value);
    let date = new Date(fulldate); //1/1/1753 12:00:00 AM and 12/31/9999 11:59:59 PM
    let startLimit = new Date("1/1/1753 12:00:00 AM");
    let endLimit = new Date("12/31/9999 11:59:59 PM");
    detail[name] = value;
    this.setState({ pagination: { ...detail } }, () => {
      if (startLimit < date && date < endLimit) {
        this.getAllBookingWaitingList();
      } else if (fulldate === null) {
        this.getAllBookingWaitingList();
      }
    });
  }

  exportAllViewWaitingMembers = () => {
    let request = { ...this.state.pagination };
    request.pageSize = 100000;
    this.BookingServices.exportAllViewWaitingMembers(request)
      .then((response) => {
        if (response.status === 200 && response.data != null) {
          let blob = new Blob([response.data]);
          if (blob.size > 300) {
            saveAs(blob, `WaitingReport.xlsx`);
          } else {
            this.swalServices.Error("No Records Found!");
          }
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoading: false });
      });
  };

  componentDidMount() {
    this.getAllBookingWaitingList();
  }

  render() {
    return (
      <div className="main-body-section View-booking-sec">
        <div className="custom-card">
          <div className="common-top-filter-bar">
            <div className="date-range-select">
              <input
                id="default"
                name="dateFrom"
                className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                type="date"
                value={this.state.pagination.dateFrom}
                onChange={(e) => this.handleChange(e)}
              />
              <h2 className="theme-label-left mr-0">To</h2>
              <input
                id="default"
                name="dateTo"
                className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                type="date"
                value={this.state.pagination.dateTo}
                onChange={(e) => this.handleChange(e)}
              />
            </div>
            <div className="search-bar-container">
              <div className="theme-label-left filter-label w-[100%]">Search by Event Name/Requestor Email</div>
              {/* <input className="col-span-2 text-lg font-bold  h-[40px] w-full text-[#757575]"/> */}
              <input
                id="default"
                className="col-span-2 text-lg font-bold h-[55px] w-full text-[#757575] border-white"
                type="text"
                onChange={(e) => this.searchByName(e.target.value)}
              />
               <button
                    className="btn btn-red text-white"
                    onClick={() => this.exportAllViewWaitingMembers()}
                  >
                    <p className="tracking-normal">
                      Export
                    </p>
                  </button>
            </div>
          </div>
          <div className="bottom-result-table">
            {/* Table Section Start */}
            <div className="mt-10 view-waiting-list-table">
              <Table
                columns={[
                  { name: "EventName", title: "Event Name" },
                  { name: "EventDate", title: "Event Date" },
                  { name: "seatAvailablity", title: "Seat Availability" },
                  { name: "requestorName", title: "Requestor Name" },
                  { name: "RequestorContactNumber", title: "Requestor Contact Number" },
                  { name: "requestorEmailAddress", title: "Requestor Email Address" },
                  { name: "isNotified", title: "Status" },
                  { name: "EventId", title: "Actions" },

                ]}
                rows={this.state.bookingWaitingList}
                isLoading={this.state.isLoading}
                pagination={this.state.pagination}
                totalResultes={this.state.totalResultes}
                totalCount={this.state.totalResultes}
                sortingColumns={[""]}
                setPagination={this.setPagination.bind(this)}
                customScope={[
                  {
                    column: "EventId",
                    renderTableData: this.actions.bind(this),
                  },
                ]}
              />
            </div>
            {/*Table Section End */}
          </div>
        </div>
      </div>
    )
  }
}
